import { render, staticRenderFns } from "./Booking.vue?vue&type=template&id=ec72edde&scoped=true&"
import script from "./Booking.vue?vue&type=script&lang=ts&"
export * from "./Booking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec72edde",
  null
  
)

export default component.exports